import PropTypes from 'prop-types';
import React from 'react';
import ShapedButton from './ShapedButton';
import SvgIcon from './SvgIcon';

const GoBackButton = (props) => {
    const buttonEnable = (props.isEnabled) ? '' : 'disabled-button';
    return (
        <ShapedButton
            ariaLabel={props.ariaLabel}
            styles={`comprehension-back ${buttonEnable}`}
            onClick={props.onClick}
            isEnabled={props.isEnabled}>
            <a>
                <SvgIcon ariaLabelledBy="Triangle icon" ariaDescribedBy="Triangle icon at back button" class="svg-triangle-button lantern-svg" id="triangle-button" />
                Back
            </a>
        </ShapedButton>
    );
};

GoBackButton.propTypes = {
    ariaLabel: PropTypes.string,
    onClick: PropTypes.func.isRequired,
    isEnabled: PropTypes.bool,
};

GoBackButton.defaultProps = {
    ariaLabel: '',
    isEnabled: false,
};

export default GoBackButton;
